import { render, staticRenderFns } from "./SpeakerBioModal.vue?vue&type=template&id=1b312cd5"
import script from "./SpeakerBioModal.vue?vue&type=script&lang=ts"
export * from "./SpeakerBioModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports